module.exports = __webpack_public_path__ + "images/newsletter-8ac91a9fbc37dea0007112a94fcf4166.svg";